import {ExerciseType} from 'features/WellniteExercise/utils/constants';
import {MoodTrackerEntry} from 'interfaces/MoodTracker.types';
import {WellniteContentArticle} from 'interfaces/WellniteContent.types';

export type SaveSuperCoachActionFeedbackData = {
  messageId: string;
  actionId?: string;
  feedback: boolean;
};

export type SuperCoachOnboardingData = {
  hasAgreedToDisclaimer: boolean;
};

export type SendSuperCoachChatMessageData = {
  message: string;
};

export interface SuperCoachChatMessagePagination {
  page: number;
  nextPage: number | null;
  hasMore: boolean;
}

export interface GetSuperCoachChatMessages {
  limit?: number;
  page: number;
}

export type SuperCoachChatMessages = SuperCoachChatMessagePagination & {
  items: SuperCoachChatMessage[];
};

export type SuperCoachContentTypes = WellniteContentArticle | ExerciseType;

export interface SuperCoachContentRecommendations {
  content: SuperCoachContentTypes[];
  contentModel: 'Article' | 'Exercise';
  userRequested?: boolean;
}

export enum SuperCoachEvent {
  onExerciseCompleted = 'onExerciseCompleted',
  onProgressUpdated = 'onProgressUpdated',
}

export enum SuperCoachAction {
  showMoodTrackerSummary = 'ShowMoodTrackerSummary',
  showProgressSummary = 'ShowProgressSummary',
  showAllStats = 'ShowAllStats',
  showOnSubscriptionMessage = 'ShowOnSubscriptionMessage',
  showOnExerciseCompleted = 'ShowOnExerciseCompleted',
  showOnProgressUpdated = 'ShowOnProgressUpdated',
}
export interface SuperCoachActionRecommendations {
  _id?: string;
  action: SuperCoachAction;
  title: string;
  feedback?: boolean;
  userRequested?: boolean;
}

export interface SuperCoachChatMessage {
  _id: string;
  question: string;
  response: string;
  responseHtml?: string;
  moodTrackerEntry?: MoodTrackerEntry;
  contentRecommendations?: SuperCoachContentRecommendations[];
  actionRecommendations?: SuperCoachActionRecommendations[];
  updatedAt: string | Date;
  createdAt: string | Date;
}

export type StreamedSuperCoachChatMessage = SuperCoachChatMessage & {
  currentChunk?: string;
  isStreaming?: boolean;
  isAutoEngagement?: boolean;
};

export interface SendSuperCoachChatMessageResult {
  message?: SuperCoachChatMessage;
  recommendedMessage?: SuperCoachChatMessage;
}

export type SuperCoachChatMessageStreamed = SendSuperCoachChatMessageResult & {
  text?: string;
  done?: boolean;
};

export interface GetSuperCoachRecommendationsArgs {
  event?: SuperCoachEvent;
  eventPayload?: string | number | string[];
}
